<template>
    <div class="p-6 bg-indigo-darker min-h-screen flex justify-center items-center -mt-16">
        <div class="w-full max-w-sm">
            <form class="mt-8 bg-white rounded-lg shadow-lg overflow-hidden" @submit.prevent="submit">
                <div class="px-10 py-8">
                    <img src="/img/logo.png" alt="" />
                    <div class="mx-auto mt-6 w-24 border-b-2" />
                    <text-input v-model="form.email" :errors="$page.props.errors.email" class="mt-10" label="Email" type="email" autofocus autocapitalize="off" />
                    <text-input v-model="form.password" class="mt-6" label="Password" type="password" />
                    <label class="mt-6 select-none flex items-center" for="remember">
                        <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
                        <span class="text-sm">Remember Me</span>
                    </label>
                </div>
                <div class="px-10 py-4 bg-grey-lightest border-t border-grey-lighter flex justify-between items-center">
                    <!-- <a class="hover:underline" tabindex="-1" href="#reset-password">Forget password?</a> -->
                    <loading-button :loading="sending" class="bg-teal-600 text-white px-5 py-1 rounded" type="submit">Login</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import LoadingButton from "@/admin/Shared/LoadingButton";
import TextInput from "@/admin/Shared/TextInput";

export default {
    metaInfo: { title: "Login" },
    components: {
        LoadingButton,
        TextInput
    },
    props: {
        errors: Object
    },
    data() {
        return {
            sending: false,
            form: {
                email: "",
                password: "",
                remember: null
            }
        };
    },
    methods: {
        submit() {
            this.sending = true;
            this.$inertia.post(this.route("admin.login.attempt"), {
                    email: this.form.email,
                    password: this.form.password,
                    remember: this.form.remember
                });
        }
    }
};
</script>
